<template>
  <div class="after_sale_info_warp">
    <el-alert
      v-if="$route.query.groupBuy === '1'"
      :title="`拼团订单${$route.query.teamNo ? ' · 拼团编号：' + $route.query.teamNo : ''}`"
      description="该订单来自拼团活动，拼团进度和成员请在活动管理的拼团情况中查看。"
      type="warning"
      show-icon
      :closable="false"
      class="group-buy-alert"
    />
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">收货信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="联系姓名">{{ orderInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ orderInfo.phone }}</el-descriptions-item>
          <el-descriptions-item label="联系地址">
            {{ orderInfo.countryName }}
            {{ orderInfo.provinceName }}
            {{ orderInfo.cityName }}
            <span v-if="orderInfo.areaName">{{ orderInfo.areaName }}</span>
            {{ orderInfo.address }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">订单处理日志</div>
      </div>
      <div class="card_content">
        <el-timeline v-if="orderInfo.operationLogs && orderInfo.operationLogs.length">
          <el-timeline-item
            v-for="log in orderInfo.operationLogs"
            :key="log.id || `${log.operation}-${log.ctdate}`"
            :timestamp="formatApiDate(log.ctdate)"
            placement="top"
          >
            <el-card shadow="never">
              <strong>{{ operationName(log.operation) }}</strong>
              <p>操作人：{{ log.operatorName || operatorTypeName(log.operatorType) }}</p>
              <p v-if="log.remark" class="operation-remark">说明：{{ log.remark }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无订单处理日志" :image-size="70" />
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">订单信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="订单编号">{{ orderInfo.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="用户姓名">{{ orderInfo.userName }}</el-descriptions-item>
          <el-descriptions-item label="用户手机号">{{ orderInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{
            formatApiDate(orderInfo.ctdate)
          }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{
            formatApiDate(orderInfo.payTime)
          }}</el-descriptions-item>
          <el-descriptions-item label="发货时间">{{
            formatApiDate(orderInfo.deliveryTime)
          }}</el-descriptions-item>
          <el-descriptions-item label="确认收货时间">{{
            formatApiDate(orderInfo.takeTime)
          }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            {{
              orderInfo.modifyShippingAddressStatus === 1
                ? "修改地址中"
                : getValue(ORDER_STATUS, orderInfo.status)
            }}
          </el-descriptions-item>
          <el-descriptions-item label="备注">{{ orderInfo.remark }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">商品信息</div>
        <el-button
          v-if="canModifyTracking"
          class="modify-tracking-button"
          type="primary"
          size="small"
          :loading="packageLoading"
          :disabled="listLoading"
          @click="openTrackingDialog"
        >修改单号</el-button>
      </div>
      <div class="card_content">
        <el-table :data="orderInfo.items" style="width: 100%" size="mini">
          <el-table-column prop="id" label="明细编号" width="120"></el-table-column>
          <el-table-column prop="goodsId" label="商品编号" width="120"></el-table-column>
          <el-table-column prop="title" label="商品名称"> </el-table-column>
          <el-table-column prop="sellerName" label="卖家名称" min-width="130" show-overflow-tooltip />
          <el-table-column label="商品条目" min-width="220">
            <template slot-scope="scope">
              <div class="sku-cell">
                <div>{{ scope.row.skuName || scope.row.goodsSpece || "-" }}</div>
                <div class="sku-spec" v-if="formatSkuSpec(scope.row)">
                  {{ formatSkuSpec(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mainGraph" label="商品图" width="100">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.skuImage || scope.row.mainGraph"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column prop="expressTime" label="卖家发货时间">
            <template slot-scope="scope">
              <span>{{ formatApiDate(scope.row.expressTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="expressNo" label="发货单号">
            <template slot-scope="scope">
              <div class="express-number-cell">
                <span>{{ scope.row.expressNo || "-" }}</span>
                <el-tooltip v-if="isMultiPackage" content="查看全部包裹物流" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-view"
                    class="package-view-button"
                    aria-label="查看全部包裹物流"
                    @click="openPackageDialog"
                  ></el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="expressName" label="卖家发货快递"></el-table-column>
          <el-table-column prop="unitPrice" label="商品单价"> </el-table-column>
          <el-table-column prop="buyNum" label="商品数量"> </el-table-column>
          <el-table-column prop="goodsAmount" label="商品总金额"> </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog
      title="包裹物流信息"
      :visible.sync="packageDialogVisible"
      :close-on-click-modal="false"
      width="760px"
      append-to-body
    >
      <el-table
        v-loading="packageLoading"
        :data="deliveryPackages"
        border
        size="small"
        empty-text="暂无包裹物流信息"
      >
        <el-table-column label="包裹" width="90" align="center">
          <template slot-scope="scope">包裹 {{ scope.row.packageNo || scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.status === 1 ? "已发货" : "待补充" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="expressName" label="快递公司" min-width="150">
          <template slot-scope="scope">{{ scope.row.expressName || "-" }}</template>
        </el-table-column>
        <el-table-column prop="expressNo" label="快递单号" min-width="190">
          <template slot-scope="scope">{{ scope.row.expressNo || "-" }}</template>
        </el-table-column>
        <el-table-column label="发货时间" min-width="170">
          <template slot-scope="scope">
            {{ formatApiDate(scope.row.shippedTime || scope.row.expressTime) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="packageDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改已发货快递单号"
      :visible.sync="trackingDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="!trackingSaving"
      :show-close="!trackingSaving"
      :before-close="closeTrackingDialog"
      width="860px"
      append-to-body
    >
      <el-alert title="仅修改已发货单号，快递公司及发货时间不变；保存后移动端重新查询即可看到新单号。" type="info" :closable="false" show-icon />
      <el-table :data="trackingRows" border size="small" empty-text="暂无已发货的快递单号" class="tracking-table">
        <el-table-column prop="label" label="包裹 / 明细" width="110" />
        <el-table-column prop="expressName" label="快递公司" min-width="120">
          <template slot-scope="scope">{{ scope.row.expressName || "-" }}</template>
        </el-table-column>
        <el-table-column prop="expressNo" label="当前快递单号" min-width="170" />
        <el-table-column label="新快递单号" min-width="210">
          <template slot-scope="scope">
            <el-input
              v-if="scope.row.editing"
              v-model="scope.row.newNo"
              :label="`${scope.row.label}的新快递单号`"
              :disabled="trackingSaving"
              maxlength="30"
              size="small"
              placeholder="请输入新快递单号"
              @input="scope.row.error = ''"
              @keyup.enter.native="saveTracking(scope.row)"
            />
            <span v-else>-</span>
            <div v-if="scope.row.error" role="alert" class="tracking-error">{{ scope.row.error }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="145">
          <template slot-scope="scope">
            <template v-if="scope.row.editing">
              <el-button type="text" :loading="scope.row.saving" :disabled="trackingSaving && !scope.row.saving" @click="saveTracking(scope.row)">保存</el-button>
              <el-button type="text" :disabled="trackingSaving" @click="scope.row.editing = false">取消</el-button>
            </template>
            <el-button v-else type="text" :disabled="trackingSaving" @click="editTracking(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button :disabled="trackingSaving" @click="trackingDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <div class="dialog-footer">
      <el-button type="primary" @click="returnList">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getDeliveryPackages, getOrderDetail, modifyExpressNo } from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import { AFTER_SALE_STATUS, getValue, ORDER_POSTAGES_TYPE, ORDER_STATUS } from "@/utils/enumUtile";

export default {
  name: "orderInfo",
  computed: {
    canModifyTracking() {
      return [3, 9].includes(Number(this.orderInfo.status));
    },
    isMultiPackage() {
      return this.deliveryPackages.length > 1;
    },
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_POSTAGES_TYPE() {
      return ORDER_POSTAGES_TYPE;
    },
    ORDER_STATUS() {
      return ORDER_STATUS;
    },
    AFTER_SALE_STATUS() {
      return AFTER_SALE_STATUS;
    }
  },
  data() {
    return {
      id: 0,
      orderInfo: {},
      listLoading: false,
      packageLoading: false,
      packageDialogVisible: false,
      trackingDialogVisible: false,
      trackingSaving: false,
      trackingRows: [],
      deliveryPackages: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.id = id;
      this.getList().catch(() => {}); // 请求层已展示错误，初次加载不产生未处理的 Promise。
    }
  },
  watch: {},
  methods: {
    getValue,
    operationName(value) {
      const names = {
        SUBMIT: "用户提交订单",
        IMPORT: "后台导入订单",
        DELIVERY: "订单发货",
        MODIFY_ADDRESS: "修改收货地址",
        MODIFY_EXPRESS_NO: "修改快递单号",
        CONFIRM_RECEIPT: "确认收货",
        AFTER_SALE_APPLY: "发起售后"
      };
      return names[value] || value || "订单操作";
    },
    operatorTypeName(value) {
      return { USER: "用户", ADMIN: "后台操作人", SYSTEM: "系统" }[value] || "未知操作人";
    },
    onExpressNo() {
      window.open(
        "https://www.baidu.com/s?rsv_idx=1&wd=%E6%9F%A5%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2%E5%85%A5%E5%8F%A3",
        "_blank"
      );
    },
    openPackageDialog() {
      this.packageDialogVisible = true;
    },
    async openTrackingDialog() {
      if (!this.canModifyTracking || this.packageLoading) return;
      // 查询失败不能被当作旧版无包裹订单，否则会显示错误的修改入口。
      if (!(await this.loadDeliveryPackages())) return;
      const rows = this.deliveryPackages.length
        ? this.deliveryPackages.filter(row => Number(row.status) === 1 && row.expressNo).map(row => ({
          packageId: row.id, label: `包裹 ${row.packageNo}`, expressId: row.expressId,
          expressName: row.expressName, expressNo: row.expressNo
        }))
        : (this.orderInfo.items || []).filter(row => row.expressNo).map(row => ({
          itemId: row.id, label: `明细 ${row.id}`, expressId: row.expressId,
          expressName: row.expressName, expressNo: row.expressNo
        }));
      const seen = new Set();
      this.trackingRows = rows.filter(row => {
        const key = row.packageId ? `package-${row.packageId}` : JSON.stringify([row.expressId, row.expressNo]);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      }).map(row => ({ ...row, editing: false, saving: false, newNo: "", error: "" }));
      this.trackingDialogVisible = true;
    },
    closeTrackingDialog(done) {
      if (!this.trackingSaving) done();
    },
    editTracking(row) {
      row.newNo = "";
      row.error = "";
      row.editing = true;
    },
    async saveTracking(row) {
      if (this.trackingSaving) return;
      const newNo = row.newNo.trim();
      if (!/^[A-Za-z0-9][A-Za-z0-9-]{0,29}$/.test(newNo)) {
        row.error = "请输入1至30位字母、数字或短横线";
        return;
      }
      if (newNo === row.expressNo) {
        row.error = "新单号不能与原单号相同";
        return;
      }
      this.trackingSaving = true;
      row.saving = true;
      row.error = "";
      try {
        const response = await modifyExpressNo({
          orderId: this.id, packageId: row.packageId, itemId: row.itemId,
          originalExpressNo: row.expressNo, expressNo: newNo
        });
        // 通用请求层部分业务错误仍 resolve，必须明确判断成功。
        if (response.bizcode !== 100 || response.data !== true) {
          row.error = response.msg || "修改失败，请刷新后重试";
          return;
        }
        const oldNo = row.expressNo;
        (this.orderInfo.items || []).forEach(item => {
          if (item.expressNo === oldNo && (row.packageId != null || item.expressId === row.expressId)) item.expressNo = newNo;
        });
        this.deliveryPackages.forEach(item => {
          if (item.id === row.packageId) item.expressNo = newNo;
        });
        row.expressNo = newNo;
        row.editing = false;
        this.$message.success("快递单号修改成功");
        // 已保存与刷新失败分开处理，避免先报成功、再报修改失败。
        try {
          await this.getList();
        } catch (error) {
          this.$message.warning("单号已修改，详情刷新失败，请刷新页面查看");
        }
      } catch (error) {
        row.error = "请求失败，请刷新确认最新单号后重试";
      } finally {
        row.saving = false;
        this.trackingSaving = false;
      }
    },
    loadDeliveryPackages() {
      if (!this.id) {
        this.deliveryPackages = [];
        return Promise.resolve();
      }
      this.packageLoading = true;
      return getDeliveryPackages({ id: this.id })
        .then(response => {
          if (response.bizcode !== 100) return false;
          this.deliveryPackages = Array.isArray(response.data) ? response.data : [];
          return true;
        })
        .catch(() => {
          this.deliveryPackages = [];
          return false;
        })
        .finally(() => {
          this.packageLoading = false;
        });
    },
    getList() {
      const id = this.id;
      if (!id) {
        return;
      }
      this.listLoading = true;
      const params = {
        id
      };
      return getOrderDetail(params)
        .then(response => {
          if (response.bizcode !== 100) throw new Error(response.msg || "详情加载失败");
          this.orderInfo = response.data || [];
          return this.loadDeliveryPackages();
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    formatSkuSpec(row) {
      if (!row || !row.specValuePath) {
        return "";
      }
      try {
        const spec = JSON.parse(row.specValuePath);
        return Object.keys(spec)
          .map(key => `${key}: ${spec[key]}`)
          .join("; ");
      } catch (e) {
        return row.goodsSpece || "";
      }
    },
    returnList() {
      this.$router.push({ path: this.$route.query.groupBuy === "1" ? "/activity/group-buy/orders" : "/order/list" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/index";

.aa {
  display: inline-block;
}

.express-number-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.package-view-button {
  min-width: 28px;
  padding: 4px;
  font-size: 16px;
}

.modify-tracking-button {
  margin-left: auto;
}

.operation-remark {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.tracking-table {
  margin-top: 16px;
}

.tracking-error {
  color: #f56c6c;
  line-height: 1.5;
}

.after_sale_info_warp {
  background-color: #eeeeee;
  padding: 20px;
  height: calc(100vh - 124px);
  overflow-y: auto;
  .group-buy-alert {
    margin-bottom: 20px;
  }
  .box-card {
    margin-bottom: 20px;
  }
  .card_title {
    display: flex;
    align-items: center;
    .card_title_fg {
      height: 22px;
      width: 4px;
      background-color: $Theme-color;
    }
    .card_title_msg {
      margin-left: 6px;
    }
  }
  .card_content {
    margin-top: 10px;
    .descriptions_mar_warp {
      margin-top: 20px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: end;
  }
  .sku-cell {
    line-height: 1.5;
  }
  .sku-spec {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
